module.exports = __webpack_public_path__ + "static/media/31E3A49B-D2DF-4C6A-BB30-8F71A34219D6.203b77e9.bin";